import { useMemo } from 'react';
import { FEATURE_FLAGS, useConfigMatch } from '../../taboola-common-frontend-modules/account-configurations';
import { useHasAccountCampaignGroups } from './useHasAccountCampaignGroups';

export const useShowCampaignGroupTooltip = () => {
    const isCampaignGroupEnabled = useConfigMatch({ [FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED]: 'true' });
    const { hasAccountCampaignGroups, isLoading } = useHasAccountCampaignGroups();
    const isMandatoryHierarchyEnabled = useConfigMatch({ [FEATURE_FLAGS.IS_MANDATORY_HIERARCHY_ENABLED]: 'true' });

    const shouldShowCampaignGroupTooltip = useMemo(() => {
        return !isLoading && !hasAccountCampaignGroups && isMandatoryHierarchyEnabled && isCampaignGroupEnabled;
    }, [isLoading, hasAccountCampaignGroups, isMandatoryHierarchyEnabled, isCampaignGroupEnabled]);

    return shouldShowCampaignGroupTooltip;
};
